import { render, staticRenderFns } from "./risk-assessment.vue?vue&type=template&id=19bf8d4d&scoped=true"
import script from "./risk-assessment.vue?vue&type=script&lang=js"
export * from "./risk-assessment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19bf8d4d",
  null
  
)

export default component.exports